const getQueryParams = () => {
    const params = new URLSearchParams(window.location.search)

    const result: { [key: string]: string } = {}
    for (const [key, value] of params.entries()) {
        result[key] = value
    }
    return result
}

export default getQueryParams
